import script from "./logo-only.vue?vue&type=script&setup=true&lang=js"
export * from "./logo-only.vue?vue&type=script&setup=true&lang=js"

import "./logo-only.vue?vue&type=style&index=0&id=c02fb52e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c02fb52e"]])

export default __exports__